import type { Client, RequestContext } from "../client";
import type { ApprovalResource } from "../resources/approvals/approvalResource";
import type { CreateApprovalCommand } from "../resources/approvals/createApprovalCommand";

export class ApprovalRepository {
    protected client: Client;

    baseUrl = "~/api/spaces/{spaceId}/servertaskapprovals/{serverTaskApprovalId}/approvals";

    constructor(
        client: Client,
        private readonly requestContext: RequestContext
    ) {
        this.client = client;
    }

    async get(serverTaskApprovalId: string, approvalId: string): Promise<ApprovalResource> {
        const args = { serverTaskApprovalId, id: approvalId };
        return await this.client.get<ApprovalResource>(this.requestContext, `${this.baseUrl}/{id}`, args);
    }

    async list(serverTaskApprovalId: string): Promise<ApprovalResource> {
        const args = { serverTaskApprovalId };
        return await this.client.get<ApprovalResource>(this.requestContext, `${this.baseUrl}/all`, args);
    }

    async create(serverTaskApprovalId: string, command: CreateApprovalCommand): Promise<ApprovalResource> {
        const args = { serverTaskApprovalId };
        return await this.client.post<ApprovalResource>(this.requestContext, `${this.baseUrl}`, command, args);
    }

    // async modify(resource: ApprovalResource): Promise<ApprovalResource> {
    //     return await this.client.put<ApprovalResource>(this.requestContext, `${this.baseUrl}/{id}`, resource, { id: resource.Id });
    // }
}
